import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useEffect, useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
// For normal brand logo
// import headerImage from '../../../assets/images/shop_floor_icon_white.png';
// For Ancofer brand logo
import headerImage from '../../../assets/images/brandLogoAncoferMobile.png';
import { VERSION_NUMBER } from "../../../constant/versionInfo";
import { AuthContext } from "../../../contexts/AuthProvider";
import { navBarItemsMobile } from './constant';
import './nav-bar-mobile.scss';

function NavBarMobile(props) {
	const { onNavigationItemClick } = props;
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { auth } = useContext(AuthContext);
	const [expanded, setExpanded] = useState(false);

	const onMenuItemClick = (menuKey, url) => {
		setExpanded(false);
		if (menuKey === 'logout') {
			navigate('/');
			localStorage.setItem('token', '');
			localStorage.setItem('selectedMenu', '');
			localStorage.setItem('filterObj', JSON.stringify({}));
			return;
		}
		localStorage.setItem('selectedMenu', menuKey);
		onNavigationItemClick(url);
	};

	useEffect(() => {
		if (auth.isOperatorNavigationDisabled) {
			setExpanded(false);
		}
	}, [auth.isOperatorNavigationDisabled]);

	return (
		<>
			<Navbar
				bg="dark" variant="dark"
				expand="xl" sticky="top"
				className="nav-bar-mobile" expanded={expanded}
			>
				<Container>
					<Navbar.Brand href="/operator">
						<img alt='' src={headerImage} />
						<div className="headline">ShopFloor Operator</div>
					</Navbar.Brand>
					<Navbar.Toggle aria-controls="navbar-nav-mobile" onClick={() => setExpanded(expanded ? false : "expanded")} disabled={auth.isOperatorNavigationDisabled} />
					<Navbar.Collapse id="navbar-nav-mobile">
						<Nav>
							<Nav.Link className="user-name" onClick={() => { }}>
								<FontAwesomeIcon icon={faUser} />{' '}{auth.name}
							</Nav.Link>
							{
								navBarItemsMobile.map((navBar) =>
									<Nav.Link disabled={auth.isOperatorNavigationDisabled}
										onClick={() => onMenuItemClick(navBar.key, navBar.url)}
										key={navBar.key}
									>
										{navBar.icon}{' '}
										{t(navBar.label)}
									</Nav.Link>)
							}
						</Nav>
						<Navbar.Text className="version-info">
							{VERSION_NUMBER}
						</Navbar.Text>
					</Navbar.Collapse>
				</Container>
			</Navbar>
		</>

	);
}

export default NavBarMobile;
